import React, { FC } from 'react';
import { Checkbox } from 'src/view/components/Controls/Checkbox/Checkbox';
import { WORKING_HOURS_ORDER_TYPE } from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/types/branchEdit';

interface IProps {
  id: WORKING_HOURS_ORDER_TYPE;
  status: boolean;
  error: boolean;
  label: string;
  onSelect: (orderType: WORKING_HOURS_ORDER_TYPE) => void;
}

const WorkingHoursOrderTypeOption: FC<IProps> = ({ id, status, error, label, onSelect }) => {
  return <Checkbox value={status} name={id} label={label} error={error} labelClassName="family-medium text-size-16" onClick={() => onSelect(id)} />;
};

export default WorkingHoursOrderTypeOption;
